import { render, staticRenderFns } from "./TuitionPaymentDetail.vue?vue&type=template&id=2b23e884"
import script from "@/controllers/custom/payment/tuition-payment-detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/payment/tuition-payment-detail.js?vue&type=script&lang=js&external"
import style0 from "./TuitionPaymentDetail.vue?vue&type=style&index=0&id=2b23e884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports